"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendedToolsDrawingControls = exports.DefaultDrawingControls = exports.drawingModeOptions = exports.DrawingModeCategory = exports.getCustomDrawingModes = exports.DrawingMode = void 0;
const mapbox_gl_draw_1 = __importDefault(require("@mapbox/mapbox-gl-draw"));
const mapbox_gl_draw_rectangle_assisted_mode_1 = __importDefault(require("@geostarters/mapbox-gl-draw-rectangle-assisted-mode"));
const gds_ux_components_1 = require("@granular/gds-ux-components");
const modes_1 = require("./modes");
const mapboxModes = mapbox_gl_draw_1.default.modes;
var DrawingMode;
(function (DrawingMode) {
    DrawingMode["SIMPLE_SELECT"] = "simple_select";
    DrawingMode["DIRECT_SELECT"] = "direct_select";
    DrawingMode["DRAW_LINE_CUT"] = "draw_line_cut";
    DrawingMode["DRAW_FREEFORM_ADD"] = "draw_freeform_add";
    DrawingMode["DRAW_FREEFORM_CUT"] = "draw_freeform_cut";
    DrawingMode["DRAW_FREEFORM_MERGE"] = "draw_freeform_merge";
    DrawingMode["DRAW_FREEFORM_REMOVE"] = "draw_freeform_remove";
    DrawingMode["DRAW_RECTANGLE_ADD"] = "draw_rectangle_add";
    DrawingMode["DRAW_RECTANGLE_CUT"] = "draw_rectangle_cut";
    DrawingMode["DRAW_RECTANGLE_MERGE"] = "draw_rectangle_merge";
    DrawingMode["DRAW_RECTANGLE_REMOVE"] = "draw_rectangle_remove";
    DrawingMode["DRAW_CIRCLE_ADD"] = "draw_circle_add";
    DrawingMode["DRAW_CIRCLE_CUT"] = "draw_circle_cut";
    DrawingMode["DRAW_CIRCLE_MERGE"] = "draw_circle_merge";
    DrawingMode["DRAW_CIRCLE_REMOVE"] = "draw_circle_remove";
    DrawingMode["DRAW_POLYGON_ADD"] = "draw_polygon_add";
    DrawingMode["DRAW_LINE_STRING_ADD_POLYGON_BUFFER"] = "draw_line_string_add_polygon_buffer";
    DrawingMode["DRAW_FIELD_POLYGON_BUFFER"] = "draw_field_polygon_buffer";
    DrawingMode["DRAW_LINE_STRING_CUTTING_STRIP"] = "draw_line_string_cutting_strip";
    DrawingMode["DRAW_POLYGON_CUT"] = "draw_polygon_cut";
    DrawingMode["DRAW_POLYGON_MERGE"] = "draw_polygon_merge";
    DrawingMode["DRAW_POLYGON_REMOVE"] = "draw_polygon_remove";
    DrawingMode["FEATURE_EDIT"] = "feature_edit";
    DrawingMode["SCALE_ROTATE"] = "scale_rotate";
    DrawingMode["TRASH"] = "trash";
    DrawingMode["UNDO"] = "undo";
    DrawingMode["REDO"] = "redo";
})(DrawingMode = exports.DrawingMode || (exports.DrawingMode = {}));
/**
 * Function to get custom drawing modes.
 *
 * Moved to a function so we can pass in args to customize how the tools work.
 */
const getCustomDrawingModes = ({ disableDragFeature, }) => ({
    [DrawingMode.SIMPLE_SELECT]: (0, modes_1.customSimpleSelect)(disableDragFeature),
    [DrawingMode.DIRECT_SELECT]: (0, modes_1.customDirectSelect)(disableDragFeature),
    [DrawingMode.DRAW_LINE_CUT]: mapboxModes.draw_line_string,
    [DrawingMode.DRAW_FREEFORM_ADD]: modes_1.FreeformMode,
    [DrawingMode.DRAW_FREEFORM_CUT]: modes_1.FreeformMode,
    [DrawingMode.DRAW_FREEFORM_MERGE]: modes_1.FreeformMode,
    [DrawingMode.DRAW_FREEFORM_REMOVE]: modes_1.FreeformMode,
    [DrawingMode.DRAW_RECTANGLE_ADD]: mapbox_gl_draw_rectangle_assisted_mode_1.default,
    [DrawingMode.DRAW_RECTANGLE_CUT]: mapbox_gl_draw_rectangle_assisted_mode_1.default,
    [DrawingMode.DRAW_RECTANGLE_MERGE]: mapbox_gl_draw_rectangle_assisted_mode_1.default,
    [DrawingMode.DRAW_RECTANGLE_REMOVE]: mapbox_gl_draw_rectangle_assisted_mode_1.default,
    [DrawingMode.DRAW_CIRCLE_ADD]: modes_1.CircleRadiusMode,
    [DrawingMode.DRAW_CIRCLE_CUT]: modes_1.CircleRadiusMode,
    [DrawingMode.DRAW_CIRCLE_MERGE]: modes_1.CircleRadiusMode,
    [DrawingMode.DRAW_CIRCLE_REMOVE]: modes_1.CircleRadiusMode,
    [DrawingMode.DRAW_POLYGON_ADD]: mapboxModes.draw_polygon,
    [DrawingMode.DRAW_LINE_STRING_ADD_POLYGON_BUFFER]: mapboxModes.draw_line_string,
    [DrawingMode.DRAW_FIELD_POLYGON_BUFFER]: mapboxModes.draw_polygon,
    [DrawingMode.DRAW_LINE_STRING_CUTTING_STRIP]: mapboxModes.draw_line_string,
    [DrawingMode.DRAW_POLYGON_CUT]: mapboxModes.draw_polygon,
    [DrawingMode.DRAW_POLYGON_MERGE]: mapboxModes.draw_polygon,
    [DrawingMode.DRAW_POLYGON_REMOVE]: mapboxModes.draw_polygon,
    [DrawingMode.FEATURE_EDIT]: (0, modes_1.customSimpleSelect)(disableDragFeature),
    [DrawingMode.TRASH]: (0, modes_1.customSimpleSelect)(disableDragFeature),
    [DrawingMode.SCALE_ROTATE]: modes_1.ScaleRotateMode,
});
exports.getCustomDrawingModes = getCustomDrawingModes;
var DrawingModeCategory;
(function (DrawingModeCategory) {
    DrawingModeCategory["ADD"] = "add";
    DrawingModeCategory["CUT"] = "cut";
    DrawingModeCategory["MERGE"] = "merge";
    DrawingModeCategory["REMOVE"] = "remove";
    DrawingModeCategory["EDIT"] = "edit";
    DrawingModeCategory["UNDO"] = "undo";
    DrawingModeCategory["REDO"] = "redo";
    DrawingModeCategory["DELETE"] = "delete";
    DrawingModeCategory["TOOLS"] = "tools";
})(DrawingModeCategory = exports.DrawingModeCategory || (exports.DrawingModeCategory = {}));
exports.drawingModeOptions = {
    [DrawingMode.DRAW_LINE_CUT]: {
        iconClass: gds_ux_components_1.GKIconName.DrawPath,
        title: "Split_using_line_tool",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_FREEFORM_ADD]: {
        iconClass: gds_ux_components_1.GKIconName.DrawFreeFormAdd,
        title: "Add_Freeform",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_FREEFORM_CUT]: {
        iconClass: gds_ux_components_1.GKIconName.DrawFreeFormAdd,
        title: "Split_using_Freeform",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_FREEFORM_MERGE]: {
        iconClass: gds_ux_components_1.GKIconName.DrawFreeFormAdd,
        title: "Merge_using_Freeform",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_FREEFORM_REMOVE]: {
        iconClass: gds_ux_components_1.GKIconName.DrawFreeFormRemove,
        title: "Remove_using_Freeform",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_RECTANGLE_ADD]: {
        iconClass: gds_ux_components_1.GKIconName.RectangleAdd,
        title: "Add_Rectangle",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_RECTANGLE_CUT]: {
        iconClass: gds_ux_components_1.GKIconName.Rectangle,
        title: "Split_using_Rectangle",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_RECTANGLE_MERGE]: {
        iconClass: gds_ux_components_1.GKIconName.RectangleAdd,
        title: "Merge_using_Rectangle",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_RECTANGLE_REMOVE]: {
        iconClass: gds_ux_components_1.GKIconName.RectangleSubtract,
        title: "Remove_using_Rectangle",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_CIRCLE_ADD]: {
        iconClass: gds_ux_components_1.GKIconName.EllipseAdd,
        title: "Add_Circle",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_CIRCLE_CUT]: {
        iconClass: gds_ux_components_1.GKIconName.Ellipse,
        title: "Split_using_Circle",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_CIRCLE_MERGE]: {
        iconClass: gds_ux_components_1.GKIconName.EllipseAdd,
        title: "Merge_using_Circle",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_CIRCLE_REMOVE]: {
        iconClass: gds_ux_components_1.GKIconName.EllipseSubtract,
        title: "Remove_using_Circle",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_FIELD_POLYGON_BUFFER]: {
        iconClass: gds_ux_components_1.GKIconName.Layers,
        title: "Field_boundary_buffer_label",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_LINE_STRING_CUTTING_STRIP]: {
        iconClass: gds_ux_components_1.GKIconName.BoundaryDivide,
        title: "Split_cutting_strip_buffer_label",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_LINE_STRING_ADD_POLYGON_BUFFER]: {
        iconClass: gds_ux_components_1.GKIconName.Timeline,
        title: "Add_cutting_strip_buffer_label",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_POLYGON_ADD]: {
        iconClass: gds_ux_components_1.GKIconName.PolygonAdd,
        title: "Add_Polygon",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_POLYGON_CUT]: {
        iconClass: gds_ux_components_1.GKIconName.Polygon,
        title: "Split_using_Polygon",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_POLYGON_MERGE]: {
        iconClass: gds_ux_components_1.GKIconName.PolygonAdd,
        title: "Merge_using_Polygon",
        processOnCreate: true,
    },
    [DrawingMode.DRAW_POLYGON_REMOVE]: {
        iconClass: gds_ux_components_1.GKIconName.PolygonSubtract,
        title: "Remove_using_Polygon",
        processOnCreate: true,
    },
    [DrawingMode.FEATURE_EDIT]: {
        iconClass: gds_ux_components_1.GKIconName.Edit,
        title: "Modify_the_points_of_selected_shape",
        processOnCreate: false,
    },
    [DrawingMode.SCALE_ROTATE]: {
        // iconClass: GKIconName.MyLocation,
        iconClass: "gi scale_rotate",
        title: "Scale & Rotate",
        processOnCreate: false,
    },
    [DrawingMode.TRASH]: {
        iconClass: gds_ux_components_1.GKIconName.DeleteOutline,
        title: "Delete",
    },
    [DrawingMode.UNDO]: {
        iconClass: gds_ux_components_1.GKIconName.Undo,
        title: "Undo",
    },
    [DrawingMode.REDO]: {
        iconClass: gds_ux_components_1.GKIconName.Info,
        title: "Redo",
    },
};
exports.DefaultDrawingControls = {
    [DrawingModeCategory.ADD]: [
        DrawingMode.DRAW_CIRCLE_ADD,
        DrawingMode.DRAW_RECTANGLE_ADD,
        DrawingMode.DRAW_POLYGON_ADD,
    ],
    [DrawingModeCategory.REMOVE]: [
        DrawingMode.DRAW_CIRCLE_REMOVE,
        DrawingMode.DRAW_RECTANGLE_REMOVE,
        DrawingMode.DRAW_POLYGON_REMOVE,
    ],
    [DrawingModeCategory.EDIT]: [DrawingMode.FEATURE_EDIT],
    [DrawingModeCategory.UNDO]: [DrawingMode.UNDO],
    [DrawingModeCategory.DELETE]: [DrawingMode.TRASH],
};
exports.ExtendedToolsDrawingControls = Object.assign(Object.assign({}, exports.DefaultDrawingControls), { [DrawingModeCategory.CUT]: [
        DrawingMode.DRAW_LINE_CUT,
        DrawingMode.DRAW_POLYGON_CUT,
    ], [DrawingModeCategory.TOOLS]: [
        DrawingMode.DRAW_FIELD_POLYGON_BUFFER,
        DrawingMode.DRAW_LINE_STRING_ADD_POLYGON_BUFFER,
        DrawingMode.DRAW_LINE_STRING_CUTTING_STRIP,
    ], [DrawingModeCategory.EDIT]: [
        DrawingMode.FEATURE_EDIT,
        DrawingMode.SCALE_ROTATE,
    ] });
